function internationalNumberFilter() {
    'ngInject';

    return (number, prefix) => {
        if (number && prefix) {
            return `${prefix} ${number}`;
        } else if (number) {
            return `${number}`;
        } else {
            return '';
        }
    };
}

angular.module('BB').filter('international_number', internationalNumberFilter);




// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/international_number.filter.js